// extracted by mini-css-extract-plugin
export default {"icon":"SocialMedia_icon__+kZVw"};